import CreateSlideForm from "../../../components/admin/slides/CreateSlideForm";
import Admin from "../../Admin";


const Slides = () => {
    
    return ( <Admin>
                <CreateSlideForm/>
        
        </Admin> );
}
 
export default Slides;